import { HasGate } from '../features/accounts/components/HasGate';
import { MyPlaylistsTabs } from '../features/myPlaylists';
import { MyPlaylistsTabsLegacy } from '../features/myPlaylists/components/MyPlaylistsTabsLegacy';
import useWootricSurvey from '../hooks/useWootricSurvey';
import { jsx as _jsx } from "react/jsx-runtime";
export const MyPlaylists = () => {
  useWootricSurvey('CSAT');
  return /*#__PURE__*/_jsx(HasGate, {
    fallback: /*#__PURE__*/_jsx(MyPlaylistsTabsLegacy, {}),
    gate: "Academy:UnifiedAcademy:Navigation",
    children: /*#__PURE__*/_jsx(MyPlaylistsTabs, {})
  });
};
export default MyPlaylists;